import { useEffect } from 'react'

import { setAxiosAuthorizationToken } from 'config/axios'
import storage from 'config/storage'
import { storageAuthName } from 'constants/storage'
import { useTwoFactorAuth } from 'modules/auth/store'
import { useLocalStorage, useSessionStorage } from 'usehooks-ts'

export const useAuthenticated = () => {
  const [authLS] = useLocalStorage<{ value: boolean } | null>(storageAuthName, { value: false })
  const [authSession] = useSessionStorage<{ value: boolean } | null>(storageAuthName, { value: false })
  const hasAuthFlag = Boolean(authLS?.value || authSession?.value)
  const token = storage.getToken()
  const authenticated = hasAuthFlag && Boolean(token)

  useEffect(() => {
    if (hasAuthFlag && !token) {
      storage.clearToken()
    }
  }, [hasAuthFlag, token])

  if (token) {
    setAxiosAuthorizationToken(token)
    useTwoFactorAuth.persist.clearStorage()
  }

  return { authenticated }
}
